import { yodaOrdersConstants } from "../constants";
import { yodaOrdersService } from "../services";
import { yodaCatalogueActions } from "./yodaCatalogue.actions";
import { yodaUtilsActions } from "./yodaUtils.actions";

export const yodaOrdersActions = {
  getAll,
  getAllHeaders,
  getOrderById,
  createHeader,
  addRow,
  updateRow,
  removeRow,
  removeOrder,
  getOrderConfiguration,
  getOrderDetails,
  getOrderDetailsRow,
  orderIdReset,
  switchOrder,
  getAllAdminDraft,
  WaitingForConfirmation,
  resetError,
  orderReset,
  resetOldOrder,
  removeProduct,
  generateReport,
  concurrentUpdateRow,
  concurrentUpdateRowAuto,
  loading,
  getOrderShippingCost,
  getStatusOrder,
  changeLanguage,
  transmitOrder,
};

function getAll(customerId, agentId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getAll(customerId, agentId).then(
      (response) => {
        if (
          response.results !=
          null /* && response.results != undefined && response.results.length > 0*/
        ) {
          const { results } = response;
          dispatch(success(results));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getAll",
      { customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GETALL_REQUEST };
  }

  function success(orders) {
    return { type: yodaOrdersConstants.GETALL_SUCCESS, payload: { orders } };
  }

  function failure(error) {
    return { type: yodaOrdersConstants.GETALL_FAILURE, payload: { error } };
  }
}

function getAllHeaders(customerId, page = 1, pageSize = 10000) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getAllHeaders(customerId, page, pageSize).then(
      (response) => {
        if (
          response?.results !=
          null /* && response.results != undefined && response.results.length > 0*/
        ) {
          dispatch(success(response.results.reverse()));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getAllHeaders",
      { customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GETALL_HEADER_REQUEST };
  }

  function success(orders) {
    return {
      type: yodaOrdersConstants.GETALL_HEADER_SUCCESS,
      payload: { orders },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GETALL_HEADER_FAILURE,
      payload: { error },
    };
  }
}

function getOrderDetails(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getOrderDetails(id).then(
      (response) => {
        dispatch(success(response));
        const ids = [
          ...new Set(
            response.results.map((o) =>
              o.id.replace(new RegExp("_.*", "g"), ""),
            ),
          ),
        ];
        ids.forEach((e) => {
          dispatch(yodaOrdersActions.getOrderDetailsRow(id, e));
        });
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getOrderDetails",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GET_DETAILS_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.GET_DETAILS_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GET_DETAILS_FAILURE,
      payload: { error },
    };
  }
}

function getSilentOrderDetails(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getOrderDetails(id).then(
      (response) => {
        if (response?.results?.length > 0) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getSilentOrderDetails",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GET_SILENT_DETAILS_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.GET_SILENT_DETAILS_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GET_SILENT_DETAILS_FAILURE,
      payload: { error },
    };
  }
}

function getOrderDetailsRow(id, row) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getOrderDetailsRow(id, row).then(
      (response) => {
        if (response != null && response != undefined) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getOrderDetailsRow",
      { id, row },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GET_ROW_DETAILS_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.GET_ROW_DETAILS_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GET_ROW_DETAILS_FAILURE,
      payload: { error },
    };
  }
}

function getOrderById(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getOrderById(id).then(
      (response) => {
        if (response != null && response != undefined) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getOrderById",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GETONE_REQUEST };
  }

  function success(order) {
    return { type: yodaOrdersConstants.GETONE_SUCCESS, payload: { order } };
  }

  function failure(error) {
    return { type: yodaOrdersConstants.GETONE_FAILURE, payload: { error } };
  }
}

function createHeader(model) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.createHeader(model).then(
      (response) => {
        if (
          response !=
          null /* && response.results != undefined && response.results.length > 0*/
        ) {
          //const { results, } = response;
          dispatch(success(response));

          // navigate directly to somewhere ?
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.createHeader",
      { model },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.CREATE_HEADER_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.CREATE_HEADER_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.CREATE_HEADER_FAILURE,
      payload: { error },
    };
  }
}

function concurrentUpdateRow(id, model, index, val, identifier, sizeCode) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.concurrentUpdateRowSingle(id, model).then(
      (response) => {
        if (response != null && !response.message) {
          dispatch(success(response, index, val, identifier, sizeCode));
          dispatch(getSilentOrderDetails(id));
          dispatch(getStatusOrder(id));
          dispatch(requestEnd());
        } else {
          dispatch(failure(response, index, val, identifier, sizeCode));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.concurrentUpdateRowSingle",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_REQUEST };
  }

  function success(order, index, val, identifier, sizeCode) {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_SUCCESS,
      payload: { order, index, val, identifier, sizeCode },
    };
  }

  function failure(error, index, val, identifier, sizeCode) {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_FAILURE,
      payload: { error, index, val, identifier, sizeCode },
    };
  }

  function requestEnd() {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SINGLE_REQUEST_END,
    };
  }
}

function concurrentUpdateRowAuto(list) {
  return async (dispatch) => {
    const obj = list.find((el) => el !== undefined);

    dispatch(request());
    return yodaOrdersService
      .concurrentUpdateRowAutoComplete({
        orderId: +obj.orderId,
        catalogId: obj.model.catalogId,
        quantity: obj.model.quantity,
        customData: obj.model.customData,
      })
      .then(
        (res) => {
          if (obj.model.quantity === 0) {
            dispatch(successAutocancelled(res, list));
            dispatch(getSilentOrderDetails(obj.orderId));
            dispatch(getStatusOrder(obj.orderId));
            dispatch(requestEnd());
            return;
          }
          dispatch(success(res, list));
          dispatch(getSilentOrderDetails(obj.orderId));
          dispatch(getStatusOrder(obj.orderId));
          dispatch(requestEnd());
        },
        (error) => {
          dispatch(failure(error));
          dispatch(requestEnd());
        },
      );
  };

  function request() {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST,
    };
  }

  function successAutocancelled(order, list) {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_SUCCESS_AUTOCANCELLED,
      payload: { order, list },
    };
  }

  function success(order, list) {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_SUCCESS,
      payload: { order, list },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_FAILURE,
      payload: { error },
    };
  }

  function requestEnd() {
    return {
      type: yodaOrdersConstants.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE_REQUEST_END,
    };
  }
}

function addRow(orderId, data, index, val, identifier) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.addRow(orderId, data).then(
      (response) => {
        if (response != null && response.message === undefined) {
          dispatch(success(response, index, val, identifier));
        } else {
          dispatch(failure(response, index, val, identifier));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.addRow",
      { orderId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.ADD_ROW_REQUEST };
  }

  function success(order, index, val, identifier) {
    return {
      type: yodaOrdersConstants.ADD_ROW_SUCCESS,
      payload: { order, index, val, identifier },
    };
  }

  function failure(error, index, val, identifier) {
    return {
      type: yodaOrdersConstants.ADD_ROW_FAILURE,
      payload: { error, index, val, identifier },
    };
  }
}

function updateRow(orderId, rowId, data, index, val, identifier) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.updateRow(orderId, rowId, data).then(
      (response) => {
        if (response !== null && response.message == undefined) {
          dispatch(success(response, index, val, identifier));
        } else {
          dispatch(failure(response, index, val, identifier));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.updateRow",
      { orderId, rowId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.UPDATE_ROW_REQUEST };
  }

  function success(order, index, val, identifier) {
    return {
      type: yodaOrdersConstants.UPDATE_ROW_SUCCESS,
      payload: { order, index, val, identifier },
    };
  }

  function failure(error, index, val, identifier) {
    return {
      type: yodaOrdersConstants.UPDATE_ROW_FAILURE,
      payload: { error, index, val, identifier },
    };
  }
}

function removeRow(orderId, rowId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.removeRow(orderId, rowId).then(
      (response) => {
        dispatch(success(response, rowId));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.removeRow",
      { orderId, rowId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.REMOVE_ROW_REQUEST };
  }

  function success(order, rowId) {
    return {
      type: yodaOrdersConstants.REMOVE_ROW_SUCCESS,
      payload: { order, rowId },
    };
  }

  function failure(error) {
    return { type: yodaOrdersConstants.REMOVE_ROW_FAILURE, payload: { error } };
  }
}

function removeOrder(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.removeOrder(id).then(
      (response) => {
        if (response != null && response !== undefined) {
          dispatch(success(id));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.removeOrder",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.REMOVE_ORDER_REQUEST };
  }

  function success(id) {
    return { type: yodaOrdersConstants.REMOVE_ORDER_SUCCESS, payload: { id } };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.REMOVE_ORDER_FAILURE,
      payload: { error },
    };
  }
}

function getOrderConfiguration(customerId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getOrderConfiguration(customerId).then(
      (response) => {
        if (response != null && response !== undefined) {
          dispatch(success(response));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getOrderConfiguration",
      { customerId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.CONFIGURATION_ORDER_REQUEST };
  }

  function success(configuration) {
    return {
      type: yodaOrdersConstants.CONFIGURATION_ORDER_SUCCESS,
      payload: { configuration },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.CONFIGURATION_ORDER_FAILURE,
      payload: { error },
    };
  }
}

function loading(loading) {
  return (dispatch) => {
    dispatch(switchLoading(loading));
  };

  function switchLoading(loading) {
    return { type: yodaOrdersConstants.LOADING, payload: { loading } };
  }
}

function orderIdReset() {
  return (dispatch) => {
    dispatch(reset());
  };

  function reset() {
    return { type: yodaOrdersConstants.ORDER_ID_RESET };
  }
}

function resetOldOrder() {
  return { type: yodaOrdersConstants.RESET_ORDER };
}

function switchOrder(id) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.switchOrder(id).then(
      (response) => {
        dispatch(yodaCatalogueActions.clearSwapItems());
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.switchOrder",
      { id },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.SWITCH_TYPE_REQUEST };
  }

  function success() {
    return { type: yodaOrdersConstants.SWITCH_TYPE_SUCCESS, payload: {} };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.SWITCH_TYPE_FAILURE,
      payload: { error },
    };
  }
}

function getAllAdminDraft(page = 1, pageSize = 10000) {
  return (dispatch) => {
    dispatch(request());

    yodaOrdersService.getAllAdminDraft(page, pageSize).then(
      (response) => {
        if (
          response.results !=
          null /* && response.results != undefined && response.results.length > 0*/
        ) {
          dispatch(success(response.results.reverse()));
        } else {
          dispatch(failure(response));
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  function request() {
    return { type: yodaOrdersConstants.GETALL_ADMIN_DRAFT_REQUEST };
  }

  function success(orders) {
    return {
      type: yodaOrdersConstants.GETALL_ADMIN_DRAFT_SUCCESS,
      payload: { orders },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GETALL_ADMIN_DRAFT_FAILURE,
      payload: { error },
    };
  }
}

function WaitingForConfirmation(id, callback) {
  const cb = (dispatch) => {
    dispatch(request());

    yodaOrdersService.WaitingForConfirmation(id).then(
      (response) => {
        if (response.message) {
          dispatch(failure(response));
        } else {
          dispatch(success(response));

          if (callback) {
            callback();
          }
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.WaitingForConfirmation",
      { id },
      () => cb(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_FAILURE,
      payload: { error },
    };
  }
}

function transmitOrder(params, callback) {
  const cb = (dispatch) => {
    dispatch(request());

    yodaOrdersService.transmitOrder(params).then(
      (response) => {
        if (response.message) {
          dispatch(failure(response));
        } else {
          dispatch(success(response));

          if (callback) {
            callback();
          }
        }
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.WaitingForConfirmation",
      params,
      () => cb(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_REQUEST };
  }

  function success(order) {
    return {
      type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_SUCCESS,
      payload: { order },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.WAITING_FOR_CONFIRMATION_FAILURE,
      payload: { error },
    };
  }
}

function resetError() {
  return (dispatch) => {
    dispatch(reset());
  };

  function reset() {
    return { type: yodaOrdersConstants.RESET_ERROR };
  }
}

function orderReset(orderId) {
  return (dispatch) => {
    dispatch(reset());
    dispatch(yodaCatalogueActions.clearOrderCatalog());
    if (orderId) {
      dispatch(getOrderById(orderId));
      dispatch(getOrderConfiguration(localStorage.getItem("selectedCustomer")));
      dispatch(getOrderDetails(orderId));
    }
  };

  function reset() {
    return { type: yodaOrdersConstants.RESET_ORDER };
  }
}

function removeProduct(orderId, rowTypeId, productId, modelCode, colorCode) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService
      .removeProduct(orderId, rowTypeId, productId, modelCode, colorCode)
      .then(
        (response) => {
          dispatch(
            success(response, productId, rowTypeId, modelCode, colorCode),
          );
          //dispatch(getOrderById(orderId));
          dispatch(getSilentOrderDetails(orderId));
          dispatch(getStatusOrder(orderId));
        },
        (error) => {
          dispatch(failure(error));
        },
      );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.removeProduct",
      { orderId, rowTypeId, productId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.REMOVE_PRODUCT_REQUEST };
  }

  function success(order, productId, rowTypeId, modelCode, colorCode) {
    return {
      type: yodaOrdersConstants.REMOVE_PRODUCT_SUCCESS,
      payload: { order, productId, rowTypeId, modelCode, colorCode },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.REMOVE_PRODUCT_FAILURE,
      payload: { error },
    };
  }
}

function generateReport(orderId, language) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.generateReport(orderId, language).then(
      (response) => {
        dispatch(success(response));
      },
      (error) => {
        dispatch(failure(error));
      },
    );
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.generateReport",
      { orderId },
      () => callback(dispatch),
    );

  function request() {
    return { type: yodaOrdersConstants.GENERATE_REPORT_REQUEST };
  }

  function success(report) {
    return {
      type: yodaOrdersConstants.GENERATE_REPORT_SUCCESS,
      payload: { report },
    };
  }

  function failure(error) {
    return {
      type: yodaOrdersConstants.GENERATE_REPORT_FAILURE,
      payload: { error },
    };
  }
}

function getOrderShippingCost(orderId) {
  const callback = (dispatch) => {
    dispatch(request());
    yodaOrdersService.getOrderShippingCost(orderId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error)),
    );

    function request() {
      return { type: yodaOrdersConstants.GET_ORDER_SHIPPING_COST_REQUEST };
    }

    function success(shippingCost) {
      return {
        type: yodaOrdersConstants.GET_ORDER_SHIPPING_COST_SUCCESS,
        payload: { shippingCost },
      };
    }

    function failure(error) {
      return {
        type: yodaOrdersConstants.GET_ORDER_SHIPPING_COST_FAILURE,
        payload: { error },
      };
    }
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getOrderShippingCost",
      { orderId },
      () => callback(dispatch),
    );
}

function getStatusOrder(orderId) {
  const callback = (dispatch) => {
    dispatch(request());

    yodaOrdersService.getStatusOrder(orderId).then(
      (response) => dispatch(success(response)),
      (error) => dispatch(failure(error)),
    );

    function request() {
      return { type: yodaOrdersConstants.GET_STATUS_ORDER_REQUEST };
    }

    function success(response) {
      return {
        type: yodaOrdersConstants.GET_STATUS_ORDER_REQUEST_SUCCESS,
        payload: response,
      };
    }

    function failure(error) {
      return {
        type: yodaOrdersConstants.GET_STATUS_ORDER_REQUEST_FAILURE,
        payload: { error },
      };
    }
  };

  return (dispatch) =>
    yodaUtilsActions.redirectOnMissingParam(
      "yodaOrdersService.getStatusOrder",
      { orderId },
      () => callback(dispatch),
    );
}

function changeLanguage(languageCode) {
  yodaOrdersService
    .changeLanguage(languageCode)
    .then((response) => {})
    .catch((error) => {
      console.warn("change language error: ", error);
    });

  return { type: yodaOrdersConstants.CHANGE_LANGUAGE };
}
